<app-header [isCiiNRALogo]="true"></app-header>
<form [formGroup]="CiinraAuditForm" (ngSubmit)="exportFunction()" class="form-horizontal" novalidate>
  <div class="container-fluid sm-report text-center pv-10 mt-10">
    <div class="row p-0">
      <div class="form-group">
        <label class=" label-std control-label p-0 b-600 pl-0" for="">Client</label>
        <!-- <div class="col-sm-7 p-0"> -->
          <app-common-dropdown-search *ngIf="ClientList.length > 0" [data]="ClientList" [addFieldSetting]="addFieldSetting" (callEvent)="ClientListOnChange($event)"></app-common-dropdown-search>
        <!-- <select (change)="ClientListOnChange($event)" formControlName="Client_Id" name="Client" #selectedelem
          class="form-control" [(ngModel)]="ClientId">
          <option [selected]="ClientList.length >1" value="" disabled>Select</option>
          <option *ngFor="let c of ClientList" [value]="c.Client_Id" [selected]="c.selected">{{c.Client_Name}}
          </option>
        </select> -->
        <div class="error" *ngIf="CiinraAuditForm.get('Client_Id').hasError('required') && DisplayError">
          please select a client
        </div>
      </div>

      <div class="row">
        <label class="radio-inline radio_button control-label p-0 b-600 pl-0">Current Week
        </label>
        <label class="radio-inline">
          <input type="radio" name="type" value="Yes"(change)="isShowDate($event)" >
          Yes
        </label>
        <label class="radio-inline">
          <input type="radio" name="type" value="No"checked (change)="isShowDate($event)" >
          No
        </label>
      </div>
      <ng-container *ngIf="isDate == true">
      <div class="form-group row">
        <label class="label-std control-label p-0 b-600 pl-0" for="card-number">From Date</label>
        <div class='input-group date' id='datetimepicker1'>
          <input (dateTimeInput)="OnFromDateChange($event)" id="From_Date" formControlName="From_Date"
            autocomplete="off" [min]="MinDate1" [max]="maxDate1" (keydown)="BlockInput($event)"
            (keypress)="BlockInput($event)" [owlDateTimeTrigger]="dt1" class="form-control col-md-10" name="date"
            [owlDateTime]="dt1">
          <div class="input-group-addon col-md-2" [owlDateTimeTrigger]="dt1">
            <span class="fa fa-calendar"></span>
          </div>
          <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
        </div>
      </div>
      <div class="form-group">
        <label class="label-std control-label p-0 b-600 pl-0" for="card-number">To Date</label>
        <div class='input-group date' id='datetimepicker2'>
          <input (dateTimeInput)="OnToDateChange($event)" autocomplete="off" id="To_Date" formControlName="To_Date"
            [owlDateTimeTrigger]="dt2" (keydown)="BlockInput($event)" (keypress)="BlockInput($event)"
            class="form-control col-md-10" name="date2" [owlDateTime]="dt2" [min]="MinDate2" [max]="maxDate1">
          <div class="input-group-addon col-md-2" [owlDateTimeTrigger]="dt2">
            <span class="fa fa-calendar"></span>
          </div>
          <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
        </div>
      </div>
    </ng-container>
    <div class="form-group p-0">
      <label class="custom-control client-conf">
        <input type="checkbox" name="ac-active" id="ac-active" formControlName="Is_Only_Worked"
          (change)="onlyWorked($event)">
        <label for="ac-active">Only Worked</label>
      </label>
      <!-- <span class="col-md-6 p-0 text-left">
      </span> -->
    </div>
    </div>
    <div class="col-md-12 p-0 mt-10 text-left">
      <button type="submit" class="btn blue square-btn blue-hover btn-txt btn-default" [disabled]="disablesubmit">Download</button>
      <span>
        <!-- <input type="button" value="Download"
            class="btn blue square-btn blue-hover btn-txt" [disabled]="disablesubmit" />  -->
      </span>
    </div>
  </div>
</form>

<app-employee-selector-modal *ngIf="ShowModal" [AllEmployees]="Employees" (SendSelectedEmp)="SetSelectedEmp($event)"
  (CloseModal)="CloseModal($event)"></app-employee-selector-modal>
